export default function resultToPath(result: number): number[] {
    const path = (result >>> 0)
        .toString(2)
        .split('')
        .map((s) => Number(s));

    return path;
}
